import HumanResourcesTable from "./HumanResourcesTable";
import React from "react";
import { Grid } from "@mui/material";
import { useQuery } from "@apollo/client/react";
import { GetCompanyResourcesDocument, CompanyResourceResourceTypeEnum, CompanyResource } from "@/graphql/generated/graphql";

const HumanResourcesManagement: React.FC = () => {
  const { data, loading } = useQuery(GetCompanyResourcesDocument, {
    variables: {
      resourceType: CompanyResourceResourceTypeEnum.Human,
    }
  });

  return (
    <Grid container>
      <HumanResourcesTable
        loading={loading}
        data={data?.getCompanyResources as CompanyResource[] || []}
      />
    </Grid>
  );
};

export default HumanResourcesManagement;
